import React from "react";
import { Form } from "antd";
import { getFormItemLabel } from "../../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

const SignatureItem = (props) => {
  const { name, category, url } = props;
  const intl = useIntl();
  const label = getFormItemLabel(intl, category, name, null);

  return (
    <div>
      <Form.Item label={label} name={name}>
        {url ? (
          <img
            src={url}
            alt={"signature"}
            style={{
              height: "30px",
              objectFit: "contain",
            }}
          />
        ) : (
          <div className="underline" />
        )}
      </Form.Item>
    </div>
  );
};

SignatureItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
};

export default SignatureItem;
